var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.083,
    height: 17.083,
    viewBox: "0 0 17.083 17.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-presentation",
    transform: "translate(-35 -457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(35 457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M15.837,3.2H1.246A1.247,1.247,0,0,1,0,1.957V1.246A1.247,1.247,0,0,1,1.246,0H15.837a1.247,1.247,0,0,1,1.246,1.246v.712A1.247,1.247,0,0,1,15.837,3.2ZM1.246,1.068a.178.178,0,0,0-.178.178v.712a.178.178,0,0,0,.178.178H15.837a.178.178,0,0,0,.178-.178V1.246a.178.178,0,0,0-.178-.178Z",
    fill: "#45338c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(35.712 468.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M16.125,17.568H1.534a.534.534,0,0,1,0-1.068H16.125a.534.534,0,0,1,0,1.068Z",
    transform: "translate(-1 -16.5)",
    fill: "#45338c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(43.008 468.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M11.784,21.91a.534.534,0,0,1-.534-.534V17.284a.534.534,0,0,1,1.068,0v4.093A.534.534,0,0,1,11.784,21.91Z",
    transform: "translate(-11.25 -16.75)",
    fill: "#45338c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(39.983 468.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M13.584,21.915a.534.534,0,0,1-.43-.216l-2.6-3.512L7.963,21.7a.534.534,0,0,1-.858-.635l3.025-4.093a.553.553,0,0,1,.858,0l3.025,4.093a.534.534,0,0,1-.429.851Z",
    transform: "translate(-7 -16.767)",
    fill: "#45338c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(49.592 459.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M21.034,13.677a.534.534,0,0,1-.534-.534V3.534a.534.534,0,0,1,1.068,0v9.609A.534.534,0,0,1,21.034,13.677Z",
    transform: "translate(-20.5 -3)",
    fill: "#45338c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(36.424 459.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M2.534,13.677A.534.534,0,0,1,2,13.143V3.534a.534.534,0,1,1,1.068,0v9.609A.534.534,0,0,1,2.534,13.677Z",
    transform: "translate(-2 -3)",
    fill: "#45338c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPresentation);
export default __webpack_public_path__ + "static/media/icon-presentation.4204442584a13b3c1cce2c5bd9635c13.svg";
export { ForwardRef as ReactComponent };